import tinycolor from 'tinycolor2';

// Matches fe-server-search-listings getBrandingAppearance.
const isDarkColour = (colour?: string | null): boolean =>
  !!colour && tinycolor(colour).isDark();

export default isDarkColour;
